import Select, {AsyncCreatable}  from 'react-select';
import { shopifyService } from 'services';

import React, {Component} from 'react';

class ShopifyLocationsSelectField extends Component{
    constructor(props){
        super(props);
    }

    getLocations () {
		return shopifyService().getLocations(this.props.download)
		.then((json) => {
			return { options: json.data };
		});
    }

    onChange(location){
        let {input} = this.props;
        
        input.onChange(location?location.id: '');
    }

    onCreate(location){
        let {input} = this.props;
        return shopifyService().addLocation(location).then(()=>{
            this.locationSelect.select.closeMenu();
            input.onChange(location?location.id: '');
        }).catch(()=>{
            this.locationSelect.select.closeMenu();
        })
    }
    
    render(){
        let {input, meta, invalid} = this.props;
        return <div>
        	<AsyncCreatable cache={false} ref={input => this.locationSelect = input } onNewOptionClick={this.onCreate.bind(this)}  promptTextCreator={()=>("Enter to create this new location")} isSearchable={false} value={input.value} onChange={this.onChange.bind(this)} valueKey="id" labelKey="name" loadOptions={this.getLocations.bind(this)} />
            {((meta && meta.error) || invalid) && <span className="label label-danger">Pick an existing location</span>}
      </div>;
    }
} 

export default ShopifyLocationsSelectField;


// WEBPACK FOOTER //
// app/components/ShopifyLocationsField.jsx